import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "antd/dist/antd.css";
import { DatePicker } from 'antd';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import { MDBDataTable } from 'mdbreact';
// import { ExportReactCSV } from './ExportReactCSV';
import { Alert } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";


export default function Tax({ company_id }) {

  const [columnData, setColumnData] = useState([])
  const [rowData, setRowData] = useState([])


  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }


  useEffect(() => {

    axios.get(baseURL + "/get_audit/" + (company_id + "||tax"))
      .then((res) => {

        let column_data = []

        column_data.push(
          {
            label: 'Account ID',
            field: 'account_id',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Location ID',
            field: 'location_id',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Location Name',
            field: 'location_name',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Tax Name',
            field: 'tax_name',
            sort: 'asc',
            width: 150
          },
          {
            label: 'Tax On',
            field: 'tax_on',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Tax Type',
            field: 'tax_type',
            sort: 'asc',
            width: 400
          },
          {
            label: 'Per Day/ Per Rental',
            field: 'per_day_per_rental',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Amount / %',
            field: 'amount%',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Value',
            field: 'amount',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Currency',
            field: 'currency',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Applies On Sum Of',
            field: 'applied_taxes',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Applies On',
            field: 'applies_on',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created By',
            field: 'created_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated By',
            field: 'updated_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created On',
            field: 'created_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated On',
            field: 'updated_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'IP Address',
            field: 'ip_address',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Deleted?',
            field: 'deleted?',
            sort: 'asc',
            width: 100
          }

        )


        setColumnData(column_data);

        let rows_data = [];

        const myDataSet = res.data;
        for (var index = 0; index < res.data.length; index++) {


          let rowItem = {};
          const val = myDataSet[index];
          rowItem["account_id"] = val.account_id
          rowItem["location_id"] = val.location_id
          rowItem["location_name"] = val.location_name
          rowItem["tax_name"] = val.tax_name
          rowItem["tax_on"] = val.tax_on
          rowItem["tax_type"] = (val.tax_type === 'calculated' ? 'Compound Tax' : val.tax_type === 'independent' ? 'Fees' : "State Tax")
          rowItem["per_day_per_rental"] = (val.tax_type === 'independent' ? val.per_day_per_rental : "Per Rental")
          rowItem["amount%"] = (val.tax_type === 'independent' ? 'Amount' : "%")
          rowItem["currency"] = (val.tax_type === 'independent' ? val.currency : "-")
          rowItem["amount"] = (val.tax_type === 'independent' ? val.amount : val.percentage)
          rowItem["currency"] = (val.tax_type === 'independent' ? val.currency : "-")
          rowItem["applied_taxes"] = (val.tax_type === 'calculated' ? val.applied_taxes.map((tax_val, j) => j + 1 < val.applied_taxes.length ? tax_val.value + ", " : tax_val.value) : "-")
          rowItem["applies_on"] = val.applies_on
          rowItem["created_by"] = val.created_by
          rowItem["updated_by"] = val.updated_by
          rowItem["created_date"] = formatDate_withTime(new Date(val.created_date))
          rowItem["updated_date"] = formatDate_withTime(new Date(val.updated_date))
          rowItem["ip_address"] = val.ip_address
          rowItem["deleted?"] = val['deleted?']

          rows_data.push(rowItem)
        }


        setRowData(rows_data)
      }).catch((e) => { });



  }, [])


  //Table Data
  const data = {
    columns: columnData,
    rows: rowData
  };




  return (
    <>

      <div className="row mt-3">
        <div className="col-md-12">
          <h5 className="mb-3">Taxes Audit/Event Log: </h5>
          <MDBDataTable
            bordered
            large={true}
            data={data}
            sortable={true}
            responsiveLg={true}
            noBottomColumns={true}
            className='cust-table'
            btn
            
          />


        </div>
      </div>
    </>
  );
}
